module.exports = __webpack_public_path__ + "img/Refresh - Green - Selected.9a87dcf4.png";